module.exports = __webpack_public_path__ + "static/media/YM89_1.81b52771.jpg";